import React from 'react';
import { Button, IconButton } from '@mui/material';
import { MdDelete } from 'react-icons/md';

const SelectionTable = ({ rows, combinationId, onDeleteRow, onPreviewClick, isLoading }) => {
  return (
    <table size="small" className="table table-bordered table-striped">
      <thead className="table-dark">
        <tr>
          <th>File Name</th>
          <th>File Type</th>
          <th>Scenario</th>
          <th>Record Count</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <td>{Array.isArray(row.fileName) ? row.fileName.join(", ") : row.fileName}</td>
            <td>{row.fileType || 'N/A'}</td>
            <td>{row.scenario}</td>
            <td>{row.startRange}</td>
            <td className='align-items-center'>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => onPreviewClick(row.combination_id)}
                disabled={isLoading}
                sx={{
                  backgroundColor: 'var(--theme-color)',
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: 'var(--theme-color)',
                    opacity: 0.9,
                  },
                  '&:disabled': {
                    backgroundColor: '#6c757d',
                  },
                }}>
                Preview
              </Button>
              <IconButton color="error" onClick={() => onDeleteRow(row.id)} disabled={isLoading}>
                <MdDelete />
              </IconButton>

            </td>
          </tr>
        ))}
        {rows.length === 0 && (
          <tr>
            <td className='text-center' colSpan={5}>No data selected</td>
          </tr>
        )}
      </tbody>
    </table>  );
};

export default SelectionTable;
